import clsx from 'clsx';
import { format } from 'date-fns';
import { getRange } from '../../../../../util';
import { useDatePickerContext } from '../datePicker.context';
import { DatePickerView } from '../types';

export const DatePickerMonthView = () => {
  const { now, chosenDate, setCurrentView, lookedYear, setLookedMonth } = useDatePickerContext();

  return (
    <div
      className="grid"
      style={{
        gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
      }}
    >
      {getRange(0, 11).map((m) => {
        const isChosenMonth = chosenDate?.getUTCMonth() === m && chosenDate?.getUTCFullYear() === lookedYear;
        return (
          <button
            key={m}
            className={clsx(
              'grid h-8 cursor-pointer content-center rounded-full text-center text-lg text-darkMode-gray-light dark:text-darkMode-gray-light hover:bg-palette-600/10 hover:dark:text-white',
              now.getUTCMonth() === m && now.getUTCFullYear() === lookedYear && 'text-palette-600',
              isChosenMonth && '!bg-palette-600 && !text-palette-1100'
            )}
            onClick={() => {
              setLookedMonth(m);
              setCurrentView(DatePickerView.DatePicker);
            }}
          >
            {format(new Date(lookedYear, m), 'LLL')}
          </button>
        );
      })}
    </div>
  );
};
